import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Redux setup
import { Provider } from 'react-redux';
import createStore from './store/store'; // Adjust path if needed

const store = createStore(); // Create a fresh store instance

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// Optional performance logging
reportWebVitals();